<template>
    <modal
        :name="'recordatorio-' + evento_id"
        transition="pop-out"
        :adaptive="true" 
        :width="800"
        height="auto"
        scrollable
    >
        <div class="p-3 d-flex flex-column">
            <p class="text-muted small">
                {{ $t('recordatorios.venta_abierta') }} 😉
            </p>
            <div class="dropdown-divider"></div>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <div class="row">
                    <div class="col">
                        <FormInput
                            :label="$t('recordatorios.nombre')"
                            type="text"
                            name="nombre"
                            id="nombre"
                            rules="required"
                            v-model="recordatorio.nombre"
                        />
                    </div>
                    <div class="col">
                        <FormInput
                            :label="$t('recordatorios.correo')"
                            type="email"
                            name="correo"
                            id="correo"
                            rules="required|email"
                            v-model="recordatorio.email"
                        />
                    </div>
                </div>
                <div class="custom-control custom-checkbox float-right my-3">
                    <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        name="notificaciones"
                    >
                        <input
                            class="custom-control-input"
                            type="checkbox"
                            id="checkboxNotificaciones"
                            v-model="recordatorio.notificaciones"
                            rules="required"
                        />
                        <label for="checkboxNotificaciones" class="custom-control-label">
                            {{ $t('recordatorios.notificaciones') }}
                        </label>
                        <span v-if="errors[0]" class="error invalid-feedback d-block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </ValidationObserver>
            <div class="d-flex ml-auto">
                <button
                    id="botonEnviar"
                    class="btn btn-primary btn-lg mr-2"
                    @click.prevent="submit"
                >
                    {{ $t('recordatorios.enviar') }}
                </button>
                <button
                    class="btn btn-lg red-content btn-danger"
                    @click.prevent="close"
                >
                    {{ $t('recordatorios.cerrar') }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        props: ["evento_id"],
        data() {
            return {
                recordatorio: {},
                backValidationError: null,
            };
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.crearRecordatorio();
                }
            },
            crearRecordatorio() {
                let params = {
                    evento_id: this.evento_id,
                ...this.recordatorio,
                };
                this.$store
                    .dispatch(this.config.getVuexAlias("front.recordatorios.crear"), params)
                    .then(res => {
                        this.close();
                        this.$toast.success('Recordatorio anotado. ¡Te avisaremos cuando las entradas estén a la venta!');
                    })
            },
            close() {
                this.recordatorio = {};
                this.$emit("close", "recordatorio-" + this.evento_id);
            },
        },
    };
</script>
